import router from '@/router'

export interface FrontEndLogPayload {
  timestamp: string
  message: string
  stack?: string
  url: string
  route: string
  browser: string
  userAgent: string
  additionalDetails?: Record<string, unknown>
}

export interface CommonErrorLoggerInput {
  message: string
  stack?: string
  additionalDetails?: Record<string, unknown>
}

function detectBrowser(userAgent: string): string {
  if (userAgent.includes('Edg/')) return 'Edge'
  if (userAgent.includes('Chrome/')) return 'Chrome'
  if (userAgent.includes('Firefox/')) return 'Firefox'
  if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) return 'Safari'
  return 'Unknown'
}

function buildPayload(input: CommonErrorLoggerInput): FrontEndLogPayload {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  return {
    timestamp: new Date().toISOString(),
    message: input.message,
    stack: input.stack,
    url: typeof window !== 'undefined' ? window.location.href : '',
    route: router.currentRoute.value?.fullPath ?? '',
    browser: detectBrowser(userAgent),
    userAgent,
    additionalDetails: input.additionalDetails
  }
}

/**
 * Logs structured frontend errors to the console. Failures are swallowed so
 * logging never takes down the application.
 */
export async function commonErrorLogger(input: CommonErrorLoggerInput): Promise<void> {
  try {
    const payload = buildPayload(input)
    console.error('[commonErrorLogger]', payload)
  } catch (error) {
    console.error('[commonErrorLogger] Failed to build error log:', error)
    console.error('[commonErrorLogger] Original error:', input.message, input.stack)
  }
}
